import { defineStore } from 'pinia'

import { createCalculationsActions } from './actions'
import { createCalculationsState } from './state'

export const useCalculationsStore = defineStore('calculations', () => {
    const state = createCalculationsState()
    const actions = createCalculationsActions(state)

    return {
        ...state,
        ...actions
    }
})
